import { Injectable } from '@angular/core';
import { GymConfigService } from '../../services/gym-config.service';
import { canAccessRoute } from '../../auth/route-access';
import { AuthService } from '../../services/auth.service';

export interface Menu {
  state: string;
  name: string;
  type: string;
  icon: string;
}

const PAGE_CONFIG_TYPE = 'PAGE';
export interface PageEelement {
  id: number;
  name: string;
  type: string;
  isEnabled: boolean;
  createdAt: string;
  updatedAt: string;
}

const MENUITEMS = [
  { state: 'dashboard', name: 'Dashboard', type: 'link', icon: 'av_timer' },
  {
    state: 'member',
    type: 'link',
    name: 'Socios',
    icon: 'person',
  },
  { state: 'rate', type: 'link', name: 'Planes', icon: 'fact_check' },
  { state: 'courtesy', type: 'link', name: 'Cortesías', icon: 'card_giftcard' },
  { state: 'work-shift', type: 'link', name: 'Turnos', icon: 'local_atm' },
  {
    state: 'subscriptions',
    type: 'link',
    name: 'Suscripciones',
    icon: 'card_membership',
  },
  {
    state: 'new-subscription',
    type: 'link',
    name: 'Nueva Suscripción',
    icon: 'person_add',
  },
  {
    state: 'records',
    type: 'link',
    name: 'Check-In',
    icon: 'library_add_check',
  },
  { state: 'sales', type: 'link', name: 'Ventas', icon: 'local_mall' },
  { state: 'inventory', type: 'link', name: 'Inventario', icon: 'storefront' },
  { state: 'reports', type: 'link', name: 'Reportes', icon: 'description' },
  {
    state: 'check-in-catalog',
    type: 'link',
    name: 'Registros',
    icon: 'fact_check',
  },
  { state: 'calendar', type: 'link', name: 'Calendario', icon: 'calendar_month' },
  { state: 'user', type: 'link', name: 'Usuarios', icon: 'account_circle' },
  { state: 'configuration', type: 'link', name: 'Configuración', icon: 'settings' },
];

@Injectable()
export class MenuItems {
  disabledPagesByConfig: string[] = [];

  constructor(
    private readonly gymConfigService: GymConfigService,
    private readonly authService: AuthService,
  ) {
    this.getGymConfigPages();
  }

  getGymConfigPages() {
    this.gymConfigService.getGymConfigByType(PAGE_CONFIG_TYPE).subscribe({
      next: (data: PageEelement[]) => {
        this.disabledPagesByConfig = data?.filter(current => !current?.isEnabled)?.map(current => current?.name) ?? [];
      },
      error: () => {},
    });
  }

  getMenuitem(): Menu[] {
    const userRole = this.authService.getUserRole();

    return MENUITEMS.filter(item => !this.disabledPagesByConfig.includes(item.state)).filter(item =>
      canAccessRoute(item.state, userRole),
    );
  }
}
